import React, { useEffect, useRef, useState } from "react"
import { auth } from "../../firebase"
import * as Yup from "yup"
import axios from "axios"
import { useUserContext } from "../../context/usercontext"
import GLOBAL from "../../config/variable"
import { Formik, Form } from "formik"
import PhoneInput from "react-phone-number-input"
import { parsePhoneNumber } from "react-phone-number-input"

//Navigate
import { useNavigate } from "react-router-dom"
import ROUTES from "../../router/routesConstants"
//primereact
import { InputText } from "primereact/inputtext"
import { Toast } from "primereact/toast"
import { FloatLabel } from "primereact/floatlabel"
import { Dropdown } from "primereact/dropdown"
import { Button } from "primereact/button"
import { ProgressSpinner } from "primereact/progressspinner"

const profileSchema = Yup.object().shape({
  name_first: Yup.string().required("Nombre es requerido"),
  name_last: Yup.string().required("Apellido es requerido"),
  phone: Yup.string().required("Teléfono es requerido"),
  gender: Yup.string().required("Género es requerido"),
  birthDay: Yup.string()
    .required("Día de nacimiento es requerido")
    .test("is-valid-day", "Día no válido para este mes/año", function (value) {
      const { birthMonth, birthYear } = this.parent

      // Verificar si el mes y año son válidos
      if (!birthMonth || !birthYear) return true

      // Crear un objeto de fecha con el día, mes y año
      const date = new Date(birthYear, birthMonth - 1, value)

      // Verificar si la fecha es válida
      return date.getDate() === parseInt(value)
    }),
  birthMonth: Yup.string().required("Mes de nacimiento es requerido"),
  birthYear: Yup.string().required("Año de nacimiento es requerido"),
})

const months = [
  { label: "Enero", value: "1" },
  { label: "Febrero", value: "2" },
  { label: "Marzo", value: "3" },
  { label: "Abril", value: "4" },
  { label: "Mayo", value: "5" },
  { label: "Junio", value: "6" },
  { label: "Julio", value: "7" },
  { label: "Agosto", value: "8" },
  { label: "Septiembre", value: "9" },
  { label: "Octubre", value: "10" },
  { label: "Noviembre", value: "11" },
  { label: "Diciembre", value: "12" },
]

const genderOptions = [
  { label: "Masculino", value: "male" },
  { label: "Femenino", value: "female" },
  { label: "Prefiero no decirlo", value: "other" },
]

function EditProfile() {
  const navigate = useNavigate()
  const toast = useRef(null)
  const [userData, setUserData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const { user, refetchUserData } = useUserContext()

  const currentYear = new Date().getFullYear()
  const years = Array.from(
    { length: currentYear - 18 - (currentYear - 90) + 1 },
    (_, i) => currentYear - 18 - i
  )
  useEffect(() => {
    const fetchUser = async () => {
      try {
        setIsLoading(true)
        const response = await axios.get(
          `${GLOBAL.SERVER_URL}/users/${user.uid}`,
          {
            headers: {
              Authorization: `Bearer ${user.accessToken}`,
            },
          }
        )
        setUserData(response.data.data)
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Redirigir al login si la respuesta es 401
          auth.signOut()
        }
        console.error("Error", error)
      } finally {
        setIsLoading(false)
      }
    }
    if (user?.uid) {
      fetchUser()
    }
  }, [user])

  if (isLoading) {
    return (
      <div className="container flex align-items-center justify-content-center">
        <ProgressSpinner />
      </div>
    )
  }

  const handleSubmit = async (values) => {
    const birthDate = `${values.birthDay}-${values.birthMonth}-${values.birthYear}`
    try {
      await axios.put(
        `${GLOBAL.SERVER_URL}/users/${user.uid}`,
        {
          name_first: values.name_first,
          name_last: values.name_last,
          phone_number: values.phone,
          gender: values.gender,
          birth_date: birthDate,
        },
        {
          headers: {
            Authorization: `Bearer ${user.accessToken}`,
          },
        }
      )

      await refetchUserData()

      // Push successful update profile event to dataLayer
      window.dataLayer.push({
        event: "update_profile",
        user_id: user.uid,
      })
      toast.current.show({
        severity: "success",
        summary: "Éxito",
        detail: "Perfil actualizado correctamente",
        position: "top-center",
        life: 5000,
      })

      navigate(ROUTES.PROFILE, { state: { updated: true } })
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirigir al login si la respuesta es 401
        auth.signOut()
      }
      console.error("Error", error)
      // Push update profile error event to dataLayer
      window.dataLayer.push({
        event: "update_profile_error",
        error_message: error.message,
        user_id: user.uid,
      })
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
        position: "top-center",
        life: 5000,
      })
    }
  }

  const handleInitialValues = () => {
    const parsedPhone = userData.phone_number
      ? parsePhoneNumber(userData.phone_number)
      : "+50611111111"
    const birthday = userData.birth_date
      ? userData.birth_date.split("-")
      : ["", "", ""]

    return {
      name_first: userData.name_first || "",
      name_last: userData.name_last || "",
      phone: parsedPhone.number,
      gender: userData.gender,
      birthDay: birthday[0] || "",
      birthMonth: birthday[1] || "",
      birthYear: parseInt(birthday[2]) || "",
    }
  }

  return (
    <div>
      <Toast ref={toast} position="top-center" />
      <div className="profile-container mt-2">
        <h2 className="text-2xl font-bold">Mi Perfil</h2>
        <Formik
          initialValues={handleInitialValues()}
          validationSchema={profileSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            handleChange,
            handleBlur,
            values,
            errors,
            touched,
            setFieldValue,
            handleSubmit,
          }) => (
            <Form className="flex flex-column justify-content-center align-items-center">
              <div className=" lg:flex lg:justify-content-center lg:align-items-center lg:mt-2 ">
                <div className="flex flex-column my-2">
                  <FloatLabel className="profile-input profile-input-name lg:ml-5">
                    <InputText
                      id="name_first"
                      name="name_first"
                      value={values.name_first}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.name_first && errors.name_first}
                      placeholder="Nombre"
                    />
                    <label className="text-sm">Nombre</label>
                  </FloatLabel>
                  {touched.name_first && errors.name_first && (
                    <small className="text-sm mb-4">{errors.name_first}</small>
                  )}
                </div>
                <div>
                  <FloatLabel className="profile-input profile-input-name mt-5 lg:mt-0">
                    <InputText
                      id="name_last"
                      name="name_last"
                      value={values.name_last}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.name_last && errors.name_last}
                      placeholder="Apellido"
                    />
                    <label className="text-sm">Apellido</label>
                  </FloatLabel>
                  {touched.name_last && errors.name_last && (
                    <small className="text-sm mb-4">{errors.name_last}</small>
                  )}
                </div>
              </div>
              <div className="flex flex-column gap-2 xl:flex-row xl:gap-4">
                <div className="flex flex-column mb-1 mt-4">
                  <PhoneInput
                    countryCallingCodeEditable={false}
                    defaultCountry="CR"
                    internationalMode="international"
                    layout="second"
                    value={values.phone}
                    onChange={(value) => setFieldValue("phone", value)}
                    onBlur={handleBlur}
                    error={touched.phone && errors.phone}
                    placeholder="Número de teléfono"
                    className="profile-input    "
                  />
                  {touched.phone && errors.phone && (
                    <small className="text-sm mb-4">{errors.phone}</small>
                  )}
                </div>
              </div>
              <div className="flex flex-column mt-4 xl:ml-6">
                <FloatLabel className="profile-input">
                  <Dropdown
                    id="gender"
                    name="gender"
                    options={genderOptions}
                    value={values.gender}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.gender && errors.gender}
                  />
                  <label className="text-sm">Género</label>
                </FloatLabel>
                {touched.gender && errors.gender && (
                  <small className="text-sm mb-4">{errors.gender}</small>
                )}
              </div>
              <div className="flex flex-column gap-2 ">
                <label
                  className="mt-4 mb-2 text-base"
                  style={{ color: "#6b7280" }} // TEMP
                >
                  Fecha de nacimiento
                </label>
                <div className="flex flex-column gap-5 mb-4 profile-input-date ">
                  <FloatLabel className="mt-3">
                    <Dropdown
                      id="birthDay"
                      name="birthDay"
                      options={Array.from({ length: 31 }, (_, i) =>
                        (i + 1).toString().padStart(2, "0")
                      )}
                      value={values.birthDay}
                      onChange={(e) =>
                        setFieldValue("birthDay", e.target.value)
                      }
                      onBlur={handleBlur}
                      className="date-picker"
                      placeholder="Día"
                    />
                    <label className="text-sm" htmlFor="birthDay">
                      Día
                    </label>
                  </FloatLabel>

                  <FloatLabel>
                    <Dropdown
                      id="birthMonth"
                      name="birthMonth"
                      options={months}
                      value={values.birthMonth}
                      onChange={handleChange}
                      className="date-picker"
                    />
                    <label className="text-sm" htmlFor="birthMonth">
                      Mes
                    </label>
                  </FloatLabel>

                  <FloatLabel>
                    <Dropdown
                      name="birthYear"
                      value={values.birthYear}
                      options={years}
                      onChange={handleChange}
                      placeholder="Selecciona el año"
                      className="date-picker"
                    />
                    <label className="text-sm" htmlFor="birthYear">
                      Año
                    </label>
                  </FloatLabel>
                </div>
                {!values.birthDay && !values.birthMonth && !values.birthYear ? (
                  <small className="text-sm mb-4 text-red-500">
                    La fecha de nacimiento es requerida
                  </small>
                ) : (touched.birthYear && errors.birthYear) ||
                  errors.birthDay ||
                  errors.birthMonth ? (
                  <small className="text-sm mb-4 text-red-500">
                    {errors.birthDay || errors.birthMonth || errors.birthYear}
                  </small>
                ) : null}
              </div>
              <div className="flex flex-row gap-2">
                <Button
                  severity="secondary"
                  type="submit"
                  label="Guardar"
                  onClick={handleSubmit}
                />
                <Button
                  severity="info"
                  type="button"
                  label="Cancelar"
                  onClick={() => navigate(ROUTES.PROFILE)}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default EditProfile
